/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../Layouts/Layout";
import { Helmet } from "react-helmet-async";
import Container from "../../../../components/Container/Container";
import error404PageStyle from "./error404PageStyle";
import Typography from "@mui/material/Typography";
import { gaSet } from "../../../../services/googleAnalyticsService";
import Grid from "@mui/material/Grid";
import LogoBird from "@/src/components/Logo/LogoBird";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { Box, Button, Stack } from "@mui/material";
import { Link } from "react-router";

export default function Error404Page() {
  const { isLoading, isLoggedIn } = useCustomer();
  const title = "404 | Legalbird";
  gaSet({ title: title });

  if (isLoading) {
    return null;
  }

  return (
    <Layout minimal backgroundType={"homepage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Container variant={"lg"} showPaddingBlock={false}>
        <Grid container spacing={4} sx={error404PageStyle.container}>
          <Grid size={{ xs: 12, md: 6 }}>
            <LogoBird sx={error404PageStyle.logoBird} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }} sx={error404PageStyle.textColumn}>
            <Stack sx={{ height: "100%", justifyContent: "center" }}>
              <Typography variant={"h2"} component={"h1"}>
                Die gewünschte Seite wurde nicht gefunden
              </Typography>
              <Typography sx={{ marginBlock: "1.5rem 2rem" }}>
                {isLoggedIn
                  ? "Die von Ihnen aufgerufene Seite existiert leider nicht mehr oder der Link ist veraltet. Über unsere Servicewelt gelangen Sie schnell wieder zu den aktuellen Inhalten."
                  : "Die von Ihnen aufgerufene Seite existiert leider nicht mehr oder der Link ist veraltet. Über unsere Startseite gelangen Sie schnell wieder zu den aktuellen Inhalten."}
              </Typography>
              <Box>
                <Button to={isLoggedIn ? "/servicewelt" : "/"} variant={"contained"} component={Link}>
                  {isLoggedIn ? "Zur Servicewelt" : "Zur Startseite"}
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Container>
      <br />
    </Layout>
  );
}
